import { palette } from './palette';

export const typography = {
  fontFamily: ['Roboto', 'sans-serif'].join(','),
  h1: {
    fontSize: '24px',
    fontWeight: 700,
    lineHeight: '32px',
    letterSpacing: 0,
    color: palette.text.primary,
  },
  h2: {
    fontSize: '20px',
    fontWeight: 500,
    lineHeight: '28px',
    letterSpacing: 0,
  },
  h3: {
    fontSize: '18px',
    fontWeight: 600,
    lineHeight: '28px',
    color: palette.text.primary,
  },
  body1: {
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: 'normal',
    color: palette.text.primary,
  },
  body2: {
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '24px',
  },
  caption: {
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '18px',
  },
  label: {
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '20px',
  },
  oldReleaseCardListItem: {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
  },
  username: {
    fontSize: '16px',
    fontWeight: 700,
    lineHeight: '20px',
  },
};
